import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AppState } from '../../../../app.reducer';
import { Store } from '@ngrx/store';
import { DeleteFile, DownloadDocument, GetFilesInMyFolder } from "../_store/resources.actions";
import { MatTableDataSource } from '@angular/material';
import { MoveFilesComponent } from '../move-files-dialogue/move-files.component';

@Component({
  selector: 'doc-list-document',
  templateUrl: './doc-list-view.component.html',
  styleUrls: ['./doc-list-view.component.scss']
})

export class DocumentListComponent implements OnInit {
  
  displayedColumns: string[] = ["Name", "Date", "tags"]
  dataSource: MatTableDataSource<any>
  documentsList = []

  @Input() documents: any = {};
  @Input() currentFolderId: string
  @Input() pageNumber: Number = 1
  @Output() clickedDocumentEvent: EventEmitter<any> = new EventEmitter();
  @Input() showOptions: any = false;


  constructor(
    private dialog: MatDialog,
    public router: Router,
    public store: Store<AppState>,
  ) { }

  ngOnInit() {
    console.log(this.documents)

    if (this.currentFolderId) {
      console.log(this.documents)
      const params = {
        page: this.pageNumber,
        limit: 30
      }
      this.store.dispatch(new GetFilesInMyFolder(this.currentFolderId, params));
      this.store.select(state => state.resources.filesInFolder).subscribe(res => {
        this.documentsList = res.docsList
        this.dataSource = new MatTableDataSource(this.documentsList)
      })
    }
    else {
      console.log(this.documents)
      this.dataSource = new MatTableDataSource(this.documents)
    }
    console.log(this.showOptions);

    if (this.showOptions) {
      this.displayedColumns.push("Action");
    }
    
    this.dataSource = new MatTableDataSource(this.documents)
  }

  openMoveDialogue(fileID: string = '', fileFlag: boolean = false) {
    const dialogRef = this.dialog.open(MoveFilesComponent, {
      width: '50%',
      panelClass: 'compose-mailbox',
      data: {
        fileId: fileID,
        Flag: fileFlag,
        currentFolderId: this.currentFolderId
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) { }
    });
  }

  onDocClick(document) {
    if (document) {
      this.router.navigate(['./home/resources/doc/' + document._id]);
    }
  }

  deleteDoc(id) {
    const payload = { isDeleted: true }
    this.store.dispatch(new DeleteFile(id, payload))
  }

  downloadDocument(docObj) {
    this.store.dispatch(new DownloadDocument(docObj._id, docObj.fileName));
  }
}
